import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { VehiclesService } from '../../shared/services/vehicles.service';
import { WatchListActions } from '../actions/WatchListActions';
import { Observable } from 'rxjs/Observable';
import { VehicleFilterService } from '../../shared/services/vehicle-filter.service';
import { VehicleSortService } from '../../shared/services/vehicle-sort.service';
import { LoadVehicleQueryParams } from '../../shared/domain';

import { Store, Action } from '@ngrx/store';
import { WatchlistApplicationState } from '../watchlist-state';
import { WatchlistUiState } from '../watchlist-ui-state';
import { UtilityService } from '@nw/ui-core-shared/services/utility.service';
import { Router } from '@angular/router';
import { MainStoreService } from "@nw/ui-core-shared/store/main-store.service";
import { AppUiActions } from "@nw/ui-core-shared/store/actions";

@Injectable()
export class VehiclesEffects {
    uiState: WatchlistUiState;

    constructor(private store: Store<WatchlistApplicationState>,
                private actions$: Actions,
                private vehiclesService: VehiclesService,
                private vehicleFilterService: VehicleFilterService,
                private vehicleSortService: VehicleSortService,
                private watchListActions: WatchListActions,
                private utilityService: UtilityService,
                private mainStoreService: MainStoreService,
                private appUiActions: AppUiActions,
                private router: Router) {

        this.store.select(state => state.watchlistUiState).subscribe(uiState => {
            this.uiState = uiState;
        });

    }

    @Effect() vehicles = this.actions$
        .ofType(WatchListActions.LOAD_WATCHLIST)
        .map(action =>  this.mainStoreService.getStore().dispatch(this.appUiActions.removeGlobalError()))
        .switchMap((action) => {
            return this.vehicleSortService.getSortOptionData().map((resp) => {
                const queryParams = {
                    sort  : this.vehicleSortService.getSortByQuery(),
                    filter: this.vehicleFilterService.getFilterQuery(),
                    orgId: window['currentSelectedOrg'],
                };
                return queryParams;
            });
        })
        .switchMap(queryParams => {
            return this.vehiclesService.loadVehicles(this.uiState.userId, queryParams)
                .map(vehicles => {
                    // get total vehicle in WL without filtere
                    vehicles.total = vehicles['metadata']['total'];
                    // return vehicles;
                    return this.watchListActions.loadWatchListSuccess(vehicles);
                })
                .retryWhen(this.utilityService.handleRetry)
                .catch((error) => {
                    // navigate to error page
                    this.router.navigate(['error']);
                    return Observable.of(this.watchListActions.loadWatchListFailed(error));
                })
        });

}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/store/effects/VehiclesEffects.ts